    export default function ProduitsGerant() {
  return <div style={{ padding: 40 }}>⏳ Produits Gérant — En construction</div>;
}